import { getValueByOperatorAndFieldType } from './field';
import { get } from './util';
/** 根据条件拼接 where sql */
export var spliceWhereSQLFragmentByConditions = function (fnParams) {
    var conditions = fnParams.conditions, params = fnParams.params, whereJoiner = fnParams.whereJoiner, entityMap = fnParams.entityMap, curEntity = fnParams.curEntity;
    var curConditions = conditions.filter(function (condition) { return condition.fieldId; });
    var conditionSqlList = [];
    curConditions.forEach(function (condition) {
        var _a, _b;
        var curSQL = '';
        if (condition.conditions) {
            curSQL = spliceWhereSQLFragmentByConditions({
                conditions: condition.conditions,
                whereJoiner: condition.whereJoiner,
                params: params,
                entityMap: entityMap,
                curEntity: curEntity,
            });
        }
        else {
            var entityMapElement = entityMap[condition.entityId];
            var field = entityMapElement === null || entityMapElement === void 0 ? void 0 : entityMapElement.fieldAry.find(function (f) { return f.id === condition.fieldId; });
            if (field) {
                var fieldName = "".concat(field.name);
                var value = condition.value || '';
                /** mapping 字段映射的实体 */
                if (entityMapElement.id !== curEntity.id) {
                    var mappingField = curEntity.fieldAry.find(function (f) { var _a, _b; return ((_b = (_a = f.mapping) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.id) === condition.entityId; });
                    var curField = (_b = (_a = mappingField === null || mappingField === void 0 ? void 0 : mappingField.mapping) === null || _a === void 0 ? void 0 : _a.entity) === null || _b === void 0 ? void 0 : _b.fieldAry.find(function (f) { return f.id === condition.fieldId; });
                    fieldName = "MAPPING_".concat((mappingField === null || mappingField === void 0 ? void 0 : mappingField.name) || entityMapElement.name) + ((curField === null || curField === void 0 ? void 0 : curField.isPrimaryKey) ? ".MAPPING_".concat((mappingField === null || mappingField === void 0 ? void 0 : mappingField.name) || entityMapElement.name, "_") : '.') + ((curField === null || curField === void 0 ? void 0 : curField.name) || field.name);
                }
                if (condition.value.startsWith('{') && condition.value.endsWith('}')) {
                    value = get(params, condition.value.substr(1, condition.value.length - 2).split('.').slice(1));
                }
                curSQL = "".concat(fieldName, " ").concat(condition.operator, " ").concat(getValueByOperatorAndFieldType(field.dbType, condition.operator, value));
            }
        }
        curSQL && conditionSqlList.push(curSQL);
    });
    /** 只有多个条件才需要括号拼接 */
    var sql = "".concat(conditionSqlList.length > 1 ? '(' : '').concat(conditionSqlList.join(" ".concat(whereJoiner, " "))).concat(conditionSqlList.length > 1 ? ')' : '');
    var prefix = '';
    /** whereJoiner 不存在表示最外层 SQL */
    if (!whereJoiner) {
        /** 当 condition 存在时 */
        // prefix = `WHERE _STATUS_DELETED = 0${sql ? ' AND ' : ''}`;
        prefix = 'WHERE ';
    }
    return prefix + sql;
};
export var spliceDeleteSQLByConditions = function (fnParams) {
    var conditions = fnParams.conditions, entities = fnParams.entities, params = fnParams.params, isEdit = fnParams.isEdit;
    var entityMap = {};
    entities.forEach(function (e) { return entityMap[e.id] = e; });
    var curEntity = entities.find(function (e) { return e.selected; });
    if (curEntity) {
        var sql = [];
        /** 前置 sql */
        // sql.push(`UPDATE ${curEntity.name}${isEdit ? '' : '__VIEW'} SET _STATUS_DELETED = 1, _UPDATE_USER_ID = "", _UPDATE_TIME = ${Date.now()}`);
        sql.push("DELETE FROM ".concat(curEntity.id));
        sql.push(spliceWhereSQLFragmentByConditions({
            conditions: [conditions],
            params: params,
            curEntity: curEntity,
            entityMap: entityMap,
        }));
        return sql.join(' ');
    }
};
